'use strict';

const badgeTokens = (theme) => ({
    badgeHeightSmall: theme.typography.lineHeight.xs,
    badgeHeightMedium: theme.typography.lineHeight.s,
    badgeHeightLarge: theme.typography.lineHeight.m,
    badgePaddingSmall: theme.space.component.x.xs,
    badgePaddingMedium: theme.space.component.x.s,
    badgePaddingLarge: theme.space.component.x.s,
    badgeDefaultBackgroundColor: theme.colors.primary.normal,
    badgeLighterBackgroundColor: theme.palette.blue400Alpha,
    badgeDefaultTextColor: theme.colors.body.textLight,
    badgeLighterTextColor: theme.palette.darkGrey,
    badgeFontSize: theme.typography.fontSize.xs,
    badgeFontFamily: theme.typography.fontFamily.regular,
    badgeFontLineHeight: theme.typography.lineHeight.xs,
    badgeFontWeight: theme.typography.fontWeight.semibold,
    badgeRadiusSmall: '0.5rem',
    badgeRadiusMedium: '0.625rem',
    badgeRadiusLarge: '0.75rem',
});

exports.badgeTokens = badgeTokens;
//# sourceMappingURL=badge.js.map
